import { render, staticRenderFns } from "./ToolbarComponent.vue?vue&type=template&id=2180de4e&scoped=true&"
import script from "./ToolbarComponent.vue?vue&type=script&lang=js&"
export * from "./ToolbarComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarComponent.vue?vue&type=style&index=0&id=2180de4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2180de4e",
  null
  
)

export default component.exports